/* global ksApp */
import paginationScroll from './pagination-scroll';

const pagination = () => {
  const handleRequest = event => {
    event.preventDefault();
    const link = event.currentTarget;
    const paged = link.dataset.to;
    const tabWrapper = link.closest('.js-paginated-tab-wrapper');
    const {
      tab,
      nonce,
      args,
      parent,
      view,
      sort,
      meta,
      taxonomy,
      query,
      flexClass,
    } = tabWrapper.dataset;

    const commonParams = new URLSearchParams();
    const urlParams = new URLSearchParams(window.location.search);
    commonParams.set('post_type', tab);
    commonParams.set('paged', paged);
    commonParams.set('nonce', nonce);
    commonParams.set('id', parent);
    commonParams.set('args', args);
    commonParams.set('view', view);
    commonParams.set('sort', sort);
    commonParams.set('meta', meta);
    commonParams.set('taxonomy', taxonomy);
    commonParams.set('is_search', ksApp.isSearch);
    commonParams.set('query', query);
    commonParams.set('flex_class', flexClass);

    const params = new URLSearchParams({
      ...Object.fromEntries(commonParams),
      ...Object.fromEntries(urlParams),
    });

    const restURL = `${ksApp.rest.url}trade/v1/ep-pagination/`;

    const xhr = new XMLHttpRequest();
    xhr.open('POST', restURL, true);

    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
    xhr.setRequestHeader('X-WP-Nonce', ksApp.rest.nonce);

    xhr.onload = () => {
      const response = JSON.parse(xhr.response);
      if (!response) {
        // eslint-disable-next-line no-console
        console.warn('Empty response');
        return;
      }

      const wrapper = document.querySelector(`[data-parent='${response.id}']`);
      const itemsWrapper = wrapper.querySelector('.js-paginated-tab');
      const paginationWrapper = wrapper.querySelector(
        `[data-pagination='${response.id}']`,
      );

      itemsWrapper.innerHTML = response.content;
      paginationWrapper.innerHTML = response.pagination;

      paginationScroll();

      // eslint-disable-next-line no-use-before-define
      bindClickEvents();
    };

    xhr.onerror = response => {
      // eslint-disable-next-line no-console
      console.error(response);
    };

    xhr.send(params);
  };

  const bindClickEvents = () => {
    const parent = document.querySelector('.js-pagination');
    if (parent) {
      const links = document.querySelectorAll('.js-pagination-trigger');
      links.forEach(link => {
        link.addEventListener('click', handleRequest);
      });
    }
  };

  bindClickEvents();
};

export default pagination;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/pagination.js